// extracted by mini-css-extract-plugin
module.exports = {"container":"PopupTitle_container__3xF8W","title":"PopupTitle_title__2V8el","divider":"PopupTitle_divider__2_w_j"};